export default "__VITE_ASSET__7c8e3adb__"